import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {

    @Output() navChanged: EventEmitter<string> = new EventEmitter<string>();
    @Output() fontChanged: EventEmitter<string> = new EventEmitter<string>();
    @Output() contrastChanged: EventEmitter<string> = new EventEmitter<string>();
    @Output() refreshed: EventEmitter<boolean> = new EventEmitter<boolean>();

    navItems: Array<string> = [
        'Flight Boards',
        'Vertical Flight Boards',
        'Barrel Pick',
        'Reserve',
        'Bourbon',
        'Irish',
        'Scotch',
        'Japanese',
        'Rye',
        'American',
        'Other',
        'Bites & Specials',
        'Drink For a Cause',
    ];

    activeItem: string = 'Flight Boards';
    fontSize: string = 'small';
    contrast: string = 'dark';
    logoSrc: string = '/assets/logo-green.svg';

    changeNav(section: string) {
        this.activeItem = section;
        this.navChanged.emit(section);
    }

    toggleFontSize(value: string) {
        this.fontSize = value;
        this.fontChanged.emit(value);
    }

    toggleContrast(value: string) {
        this.contrast = value;
        this.contrastChanged.emit(value);

        if(value === 'dark') {
            this.logoSrc = '/assets/logo-white.svg';
        } else {
            this.logoSrc = '/assets/logo-green.svg';
        }
    }

    clickedRefresh() {
        this.refreshed.emit(true);
    }

    constructor() {}

}
